var _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderTreatments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 56.5,
    r: 5,
    stroke: "#202E5F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 102.5,
    r: 3,
    stroke: "#848A9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 109L135.256 113.744L140 115.5L135.256 117.256L133.5 122L131.744 117.256L127 115.5L131.744 113.744L133.5 109Z",
    fill: "#E3E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 12L36.2556 16.7444L41 18.5L36.2556 20.2556L34.5 25L32.7444 20.2556L28 18.5L32.7444 16.7444L34.5 12Z",
    fill: "#E3E4E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6855 38.6857C46.2083 40.1629 46.2083 42.5375 46.2083 47.2918V97.7085C46.2083 107.217 46.2083 111.966 49.1627 114.921C50.8063 116.569 53.0145 117.295 56.2916 117.618V110.313C56.2916 108.307 57.0883 106.383 58.5066 104.965C59.9248 103.547 61.8484 102.75 63.8541 102.75C65.8598 102.75 67.7833 103.547 69.2016 104.965C70.6198 106.383 71.4166 108.307 71.4166 110.313V117.875H91.5833V110.313C91.5833 108.307 92.38 106.383 93.7983 104.965C95.2165 103.547 97.14 102.75 99.1458 102.75C101.151 102.75 103.075 103.547 104.493 104.965C105.911 106.383 106.708 108.307 106.708 110.313V117.623C109.985 117.295 112.194 116.564 113.837 114.921C116.792 111.966 116.792 107.217 116.792 97.7085V47.2918C116.792 42.5375 116.792 40.1629 115.314 38.6857C113.837 37.2085 111.463 37.2085 106.708 37.2085H56.2916C51.5373 37.2085 49.1627 37.2085 47.6855 38.6857Z",
    fill: "#E3E4E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.854 59.896H99.1457M63.854 75.021H84.0207M63.854 90.146H94.104",
    stroke: "#202E5F",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderTreatments);
export default __webpack_public_path__ + "static/media/placeholderTreatments.bbf5d6efc6d0fd7c246089db0536a7fc.svg";
export { ForwardRef as ReactComponent };